import { render, staticRenderFns } from "./QuestionsChat.vue?vue&type=template&id=b57b6de0&scoped=true"
import script from "./QuestionsChat.vue?vue&type=script&lang=js"
export * from "./QuestionsChat.vue?vue&type=script&lang=js"
import style0 from "./QuestionsChat.vue?vue&type=style&index=0&id=b57b6de0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57b6de0",
  null
  
)

export default component.exports